
import React, { useState } from 'react';
import AppContext from './AppContext';


const STORAGE_KEY_LANG = "site_lang";

function getInitialLang() {
  if (typeof localStorage === "undefined") return "en";
  return localStorage.getItem(STORAGE_KEY_LANG) === "es" ? "es" : "en";
}

const AppProvider = ({ children }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [line1, setLine1] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [postal, setPostal] = useState('');
  const [apt, setApt] = useState('')
  const [zipcodes, setZipcodes] = useState('');
  const [buyNow, setBuyNow] = useState('home');
  const [clientSecret, setClientSecret] = useState(null);
  const [loadingHeader, setLoadingHeader] = useState(false);
  const [orderNumber, setOrderNumber] = useState('');
  const [selectedPrice, setSelectedPrice] = useState(19900); // Default to $199 in cents
  const [leadsCount, setLeadsCount] = useState(500); // Default to 500 leads
  const [siteLang, setSiteLang] = useState(getInitialLang);
  const [preferredPaymentMethod, setPreferredPaymentMethod] = useState(null); // 'apple' | 'google' | 'paypal' | 'amazon' | null

  // Clears everything from a completed/abandoned purchase so the next visit to
  // Home starts from a blank slate (no stale clientSecret, contact info, or zip data).
  const resetPurchase = () => {
    setName('');
    setEmail('');
    setPhone('');
    setLine1('');
    setCity('');
    setState('');
    setPostal('');
    setApt('');
    setZipcodes('');
    setBuyNow('home');
    setClientSecret(null);
    setOrderNumber('');
    setSelectedPrice(19900);
    setLeadsCount(500);
    setPreferredPaymentMethod(null);
  };

  return (
    <AppContext.Provider value={{
      name, setName, email, setEmail, phone, setPhone, line1, setLine1,
      city, setCity, state, setState, postal, setPostal, apt, setApt, zipcodes, setZipcodes,
      buyNow, setBuyNow, clientSecret, setClientSecret, loadingHeader, setLoadingHeader, orderNumber, setOrderNumber,
      selectedPrice, setSelectedPrice, leadsCount, setLeadsCount,
      siteLang, setSiteLang,
      preferredPaymentMethod, setPreferredPaymentMethod,
      resetPurchase
    }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
